import manageSync from '@/views/manageSync'
import admin from '@/views/admin'
import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/login.vue')
    },
    {
        path: '/dictionary',
        name: 'dictionary',
        component: () => import('@/views/dictionary.vue')
    },
    {
        path: '/',
        name: 'layout',
        component: () => import('@/views/layout.vue'),
        children: [
            ...manageSync.routes(),
        ]
    },
    {
        path: '/',
        name: 'adminLayout',
        component: () => import('@/views/admin/adminLayout.vue'),
        meta: { isAdmin: true },
        children: [
            ...admin.routes(),
        ]
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export function isAdminRoute(){
    let path = window.location.hash.replace(/^#/, '') || '/';
    return router.resolve(path).matched.some(x => x.meta.isAdmin);
}

export default router
